export default __webpack_public_path__ + "static/media/start-en.697a9692.png";